import { AbstractControl, ValidatorFn } from '@angular/forms';

export const isPositive: ValidatorFn = (control: AbstractControl) => {
  const positive: boolean = control.value >= 0;

    return positive ? null : {isPositive: false};
};
